import initHorizontalMenu from './horizontalMenu/initHorizontalMenu';
import initAlgoliaSearchBox from './initAlgoliaSearchBox';
import initClearOnScroll from './initClearOnScroll';
import initMenuToggle from './initMenuToggle';
import initNavItemDropdownHover from './initNavItemDropdown';
import initWeatherInfo from './initWeatherInfo';

const initMenu = () => {
  initAlgoliaSearchBox('header-search-form');
  initAlgoliaSearchBox('header-search-form-sm');
  initWeatherInfo();
  initHorizontalMenu();
  initNavItemDropdownHover();
  initClearOnScroll();
  initMenuToggle('header-nav-main-menu');
  initMenuToggle('header-nav-service-menu');
  initMenuToggle('listing-sidebar');
};

export default initMenu;
